import { useState, useEffect } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Field, Text } from "@/admin/components/AdminField";

/** Um input livre de coordenada — mantém a string enquanto edita, só publica número no blur.
 *  Isso permite digitar "-", "-19", "-19.9" sem que o valor pule para 0. */
function CoordInput({ value, onChange, placeholder }) {
  const [text, setText] = useState(value === null || value === undefined ? "" : String(value));

  // Sincroniza quando o valor externo muda (ex: carregar dados)
  useEffect(() => {
    setText(value === null || value === undefined ? "" : String(value));
  }, [value]);

  const commit = () => {
    const cleaned = text.replace(",", ".");
    if (cleaned === "" || cleaned === "-" || cleaned === ".") {
      onChange(0);
      return;
    }
    const n = parseFloat(cleaned);
    onChange(Number.isFinite(n) ? n : 0);
  };

  return (
    <Text
      inputMode="decimal"
      value={text}
      onChange={(v) => setText(String(v).replace(/[^0-9.,\-]/g, ""))}
      onBlur={commit}
      placeholder={placeholder}
    />
  );
}

/** Editor for waypoints_geo: [{name, lat, lng}] */
export default function WaypointEditor({ value = [], onChange }) {
  const set = (i, patch) => onChange(value.map((p, k) => (k === i ? { ...p, ...patch } : p)));
  const add = () => onChange([...value, { name: "", lat: 0, lng: 0 }]);
  const remove = (i) => onChange(value.filter((_, k) => k !== i));

  return (
    <div className="space-y-3" data-testid="waypoint-editor">
      {value.map((w, i) => (
        <div key={i} className="grid grid-cols-1 md:grid-cols-[1fr_160px_160px_40px] gap-3 items-end">
          <Field label={`Ponto #${i + 1}`}>
            <Text value={w.name} onChange={(v) => set(i, { name: v })} placeholder="Nome do local" />
          </Field>
          <Field label="Latitude">
            <CoordInput value={w.lat} onChange={(n) => set(i, { lat: n })} placeholder="-19.9245" />
          </Field>
          <Field label="Longitude">
            <CoordInput value={w.lng} onChange={(n) => set(i, { lng: n })} placeholder="-43.9352" />
          </Field>
          <button type="button" onClick={() => remove(i)} className="w-10 h-10 grid place-items-center rounded-lg border border-[#2a2a2a] text-[#B8B8B8] hover:text-red-400">
            <Trash2 size={14} />
          </button>
        </div>
      ))}
      <button type="button" onClick={add} className="btn-ghost w-full py-3 rounded-xl text-xs inline-flex items-center justify-center gap-2">
        <Plus size={12} /> Adicionar coordenada
      </button>
    </div>
  );
}
